module.exports = __webpack_public_path__ + "img/map-icon.01e6f8a9.svg";